import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface ContentProps {
  onCTAClick: () => void;
}
export function Content({
  onCTAClick
}: ContentProps) {
  const contentFeatures = ['teoría abundante,', 'explicaciones claras,', 'organización profesional,', 'enfoque moderno,', 'contenidos útiles para el aula real.'];
  const systemBenefits = ['ahorrás tiempo,', 'reducís estrés,', 'organizás mejor tus clases,', 'mejorás la dinámica del aula,', 'y sentís que TODO ya está preparado.'];
  return <>
      <section className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-32">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-33">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-34">
            <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 text-[#1F3A5F] font-oswald uppercase tracking-wide" data-id="element-35">
              📖 CONTENIDO REALMENTE COMPLETO
            </h2>
            <p className="text-xl text-center mb-12 text-gray-600" data-id="element-36">
              Cada año fue desarrollado cuidadosamente:
            </p>

            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-37">
              {contentFeatures.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-38">
                  <CheckCircle2 className="text-[#2D6A4F] flex-shrink-0" size={24} data-id="element-39" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-40">
                    {feature}
                  </span>
                </motion.div>)}
            </div>

            <div className="text-center bg-white border-l-4 border-[#2D6A4F] p-8 rounded-r-xl shadow-sm max-w-2xl mx-auto" data-id="element-41">
              <p className="text-xl font-medium text-gray-600 mb-2" data-id="element-42">
                No son resúmenes vacíos.
              </p>
              <p className="text-2xl font-bold text-[#1F3A5F] font-playfair italic" data-id="element-43">
                Es material verdaderamente práctico y docente.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white" data-id="element-44">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-45">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-46">
            <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 text-[#1F3A5F] font-oswald uppercase tracking-wide" data-id="element-47">
              🔥 ES DIFÍCIL IMAGINAR A UN DOCENTE SIN ESTE SISTEMA
            </h2>
            <p className="text-xl text-center mb-10 text-gray-600" data-id="element-48">
              Porque una vez que lo usás:
            </p>

            <div className="bg-[#FAF7F2] rounded-2xl p-8 md:p-12 border border-gray-100 mb-12" data-id="element-49">
              <div className="space-y-4 max-w-2xl mx-auto" data-id="element-50">
                {systemBenefits.map((benefit, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.1
              }} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-51">
                    <span className="text-[#D4A574] text-2xl font-bold" data-id="element-52">•</span>
                    <span className="text-lg font-medium text-gray-800" data-id="element-53">
                      {benefit}
                    </span>
                  </motion.div>)}
              </div>
            </div>

            <div className="text-center mb-10" data-id="element-54">
              <p className="text-xl text-gray-500 mb-2 font-playfair italic" data-id="element-55">
                Este producto no reemplaza al docente.
              </p>
              <p className="text-2xl md:text-3xl font-bold text-[#1F3A5F]" data-id="element-56">
                👉 Potencia al docente.
              </p>
            </div>

            <div className="text-center" data-id="element-57">
              <button onClick={onCTAClick} className="bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-xl md:text-2xl font-bold py-5 px-10 md:px-16 rounded-xl shadow-xl transform hover:scale-105 transition-all flex items-center justify-center gap-3 mx-auto" data-id="element-58">
                SÍ, LO QUIERO YA 👉
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}